<template>
	<div class="secondPicture">
         <div class="check_header">
             <el-button size="small" @click="goBack()"  type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
            
        </div>
      <el-table
      border
      :data="secondCategory"
      style="width: 100%">
      <el-table-column
        prop="ordersn"
        :label="$t('other.a60')"
        >
      </el-table-column>
      <el-table-column
        prop="trackingNo"
        :label="$t('other.a1022')"
        >
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        :label="$t('other.a834')"
        >
      </el-table-column>
      <el-table-column
        prop="country"
        :label="$t('other.a269')"
        >
      </el-table-column>
      <el-table-column
        prop="buyerUsername"
        :label="$t('other.a849')"
        >
      </el-table-column>
    </el-table>
		
    <!-- 分页器 -->
    <div  class="Pager">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage1"
        :page-sizes="[15, 20, 30, 50]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsTotal">
        </el-pagination>
    </div>
	</div>
</template>

<script>
	import api from '../../api/api'
	import utils from  '../../utils/utils.js'
    import { mapState, mapMutations } from 'vuex'
import i18n from '@/i18n/i18n'

	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
                categoryList:[],
                secondCategory:[],
                tableData:[],
                currentPage1:1,
                goodsTotal:0,
                getDataList:{
                    categoryName :0,
                    pageNum:0,
                    pageSize:15,
                    userId:'thseller'
                }
			
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
			
				
				
			}),
			
	
		
				
		},
		watch:{
		
		},
        filters:{
            capitalize(country){
                const obj={
                    'TH':i18n.t('other.a1305'),
                    'PH':i18n.t('other.a1306'),
                    'ID':i18n.t('other.a1307'),
                    'MY':i18n.t('other.a1308'),
                    'VN':i18n.t('other.a1310'),

                }

                return obj[country]
            }
        },
		created(){
			
			this.init()
			
		
			
		},
		methods: {

            handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            
            },
            //显示当前第几页
            handleCurrentChange(val) {
            this.currentPage1 = parseInt(`${val}`);
            this.getDataList.pageNum=this.currentPage1

             api
                .getUserPictureData(this.getDataList)
                .then(res => {
                    console.log(res)
                    if(res.code === 'ok'){
                        
                        this.secondCategory=res.userPortraits
                        this.goodsTotal=res.pageInfo.total
                        
                    }
                })

          
            console.log(this.currentPage1);
            },
            init(){
                this.getDataList.buyerUserName=this.$route.query.buyerName
                api
                .buyerUser(this.getDataList)
                .then(res => {
                    if(res.code === 'ok'){
                        console.log(res)
                       this.secondCategory=res.orders
                       this.goodsTotal=res.pageInfo.total
                        
                    }
                })
            },

            goBack(){
                this.$router.push({
                    path:'/secondPicture',
                    query:{
                       
                        categoryName:this.$route.query.categoryName

                    }
                })
            },
            cateGory(item,index){
                console.log(item,index)
               
                // if(index == 1){
                //     api
                //     .getUserPictureData({
                //         categoryName :item.category,
                //         pageNum:0,
                //         pageSize:15,
                //         userId:'indonesia'
                //     })
                //     .then(res => {
                //         console.log(res)
                //         if(res.code === 'ok'){
                            
                //             this.secondCategory=res.userPortraits
                            
                //         }
                //     })

                // }else if(index == 2) {
                //     api
                //     .buyerUser({
                //         buyerUserName  :item.userName,
                //         pageNum:0,
                //         pageSize:15,
                //         userId:'indonesia'
                //     })
                //     .then(res => {
                //         if(res.code === 'ok'){
                //             console.log(res)
                //            this.tableData=res.orders
                            
                //         }
                //     })
                // }

            },
        }
	}
</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.secondPicture{

    // flex:1;
    // margin: 50px 0 0 223px;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;

    .check_header{
        padding: 20px 0;
    }

    .first_wrapper{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .first_category{
        width: 400px;
        height: 300px;
        box-sizing: border-box;
        padding: 5px;
        margin: 10px 10px;
        border-radius: 3px;
        border: 1px solid #409eff;

        .item_category{
            padding:4px;
            border-bottom: 1px solid #eee;
        }

        .item_category:nth-child(1){
            font-size: 18px;
            font-weight: bold;
        }

        .item_category:nth-child(8){
            font-size: 18px;
            font-weight: bold;
            cursor: pointer;
            color: #409eff;
            text-align: right;
        }
       }
    }
     .Pager{
    position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
        z-index: 999;
	
  }


  .viewOrder{
      color: #409eff;
      cursor: pointer;
  }

  

      
      
   

     
    

   
}

	
	

</style>
